import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, Checkbox, Tooltip } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import React from "react";

import { language } from "../../../../language";
import { getUnitPropertie } from "../../../smart/camunda/forms/functions";
import { findIndexDefaultValue } from "../helper";

function DisableFieldOptions({
  onCheckChange,
  handleDefaultValueChange,
  addRowDefaultValue,
  deleteDefaultValueRow,
  state,
  setObjeto,
}) {
  const indexTableOption = findIndexDefaultValue(state, "waitVariablesOptions");
  const waitVariables = getUnitPropertie(state, "waitVariables");

  const tableValues = state?.properties?.[indexTableOption];

  const onLocalCheckChange = (event) => {
    onCheckChange(event);

    if (indexTableOption < 0) {
      const helper = state.properties;
      helper.push({
        id: "waitVariablesOptions",
        value: [],
      });

      setObjeto({ ...state, properties: helper });
    }
  };

  return (
    <React.Fragment>
      <FormControl fullWidth>
        <Tooltip title={language.disableModelerFieldToolTip} placement="right">
          <FormControlLabel
            label={language.waitVariableToBeFilled}
            control={
              <Checkbox
                name="waitVariables"
                onChange={(event) => onLocalCheckChange(event)}
                value={waitVariables}
                checked={waitVariables || false}
              />
            }
          />
        </Tooltip>
      </FormControl>
      {waitVariables && (
        <React.Fragment>
          <Button
            variant="contained"
            color="primary"
            onClick={() => addRowDefaultValue("waitVariablesOptions")}
            startIcon={<AddIcon />}
          >
            {language.addVariable}
          </Button>
          <table id="table" class="table table-hover">
            <thead>
              <tr>
                <th>{language.variableID}</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {tableValues &&
                tableValues.value &&
                tableValues.value.map((item, index) => {
                  return (
                    <tr key={`tr_${index}`}>
                      <td>
                        <input
                          style={{ width: "100%" }}
                          name="key"
                          value={tableValues.value[index].key}
                          onChange={(event) =>
                            handleDefaultValueChange(
                              event,
                              index,
                              "waitVariablesOptions",
                            )
                          }
                        />
                      </td>
                      <td>
                        <DeleteIcon
                          sx={{ cursor: "pointer" }}
                          onClick={() =>
                            deleteDefaultValueRow(index, "waitVariablesOptions")
                          }
                        />
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default DisableFieldOptions;
